import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Role } from '../../models/role';

@Injectable()
export class AuthUtils {

	private readonly CLAIM_PORTAL_ROLE_PREFIX =
		'urn:aon:role:neo9-backoffice-aqua-claim-portal-';

	public constructor(private keycloakService: KeycloakService) {}

	public isAdmin(): boolean {
		const roles = this.keycloakService.getUserRoles();
		return roles.some(role => role === Role.Admin);
	}

	public getUserEnabledContexts(): string[] {
		const roles = this.keycloakService.getUserRoles();
		return roles
			.filter(role => role.includes(this.CLAIM_PORTAL_ROLE_PREFIX))
			.map(role => this.getContextCodeFromRole(role));
	}

	private getContextCodeFromRole(role: string): string {
		return role
			.substring(this.CLAIM_PORTAL_ROLE_PREFIX.length)
			.toUpperCase()
			.replace('-', '_');
	}
}

